import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import LuminartLogo from "./LuminartLogo";
import { WHYUS_BG } from "../campaigns";
import { useSiteText } from "../lib/content";

const ease = [0.16, 1, 0.3, 1];

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const BottomStrip = () => {
  const t = useSiteText();
  const COLS = [
    {
      label: t("strip1_label", "Based in London"),
      copy: t("strip1_text", "Delivering projection projects across the UK and Europe."),
      cta: t("strip1_cta", "About Us"),
      target: "process",
      testId: "strip-about-link",
    },
    {
      label: t("strip2_label", "Equipment & Technology"),
      copy: t("strip2_text", "High brightness projectors, media servers, and industry leading software."),
      cta: t("strip2_cta", "Our Capabilities"),
      target: "capabilities",
      testId: "strip-capabilities-link",
      bg: true,
    },
    {
      label: t("strip3_label", "Have a Project in Mind?"),
      copy: t("strip3_text", "Let's bring it to life. Get in touch with our team."),
      cta: t("strip3_cta", "Get in Touch"),
      target: "contact",
      testId: "strip-contact-link",
    },
  ];
  return (
    <section
      id="about"
      data-testid="london-section"
      className="relative bg-[#0a0a0c] border-t border-white/5 overflow-hidden"
    >
      {/* LP line motif on the right edge */}
      <LuminartLogo
        className="pointer-events-none absolute -right-16 top-1/2 -translate-y-1/2 w-72 opacity-[0.05]"
        glow={false}
      />

      <div className="relative grid grid-cols-1 md:grid-cols-3 md:divide-x md:divide-white/10 border-b border-white/10">
        {COLS.map((c, i) => (
          <motion.div
            key={c.label}
            data-testid={`strip-col-${i}`}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, delay: i * 0.1, ease }}
            className="relative p-8 md:p-12 border-b md:border-b-0 border-white/10 last:border-b-0"
          >
            {c.bg && (
              <div
                className="pointer-events-none absolute inset-0 opacity-[0.12] bg-cover bg-center"
                style={{ backgroundImage: `url(${WHYUS_BG})` }}
              />
            )}
            <div className="relative">
              <span className="text-[11px] uppercase tracking-[0.3em] text-white/85">
                {c.label}
              </span>
              <div className="mt-2 h-px w-9 bg-[#c8b99d]" />
              <p className="mt-6 max-w-xs text-sm font-light leading-relaxed text-white/45">
                {c.copy}
              </p>
              <button
                onClick={() => scrollTo(c.target)}
                data-testid={c.testId}
                className="group mt-8 inline-flex items-center gap-3 border border-white/25 px-6 py-3 text-[10px] uppercase tracking-[0.25em] text-white/80 hover:border-white hover:text-white transition-colors duration-300"
              >
                {c.cta}
                <ArrowRight
                  size={13}
                  className="group-hover:translate-x-1 transition-transform duration-300"
                />
              </button>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default BottomStrip;
